import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getData({ status, page, pharmacy, delivery_type, trx_id }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/search/v2/find-by-status/country/${Enviroment.LANGUAGE}/status/${status}/page/${page}`,
			params: { pharmacy: pharmacy, delivery_type, trx_id: trx_id },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getDataById(trx_id, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/pharmacy-standard/v2/country/${Enviroment.LANGUAGE}/pharmacy/${pharmacy}/trx_id/${trx_id}/one-record`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getDataByTrxId(order_id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/search/v2/order-id/${order_id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async setRecipeValue(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.PANEL_TRACKING}/status/set-value-recipe`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	
	async shareOrder(body, trxId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/email/shared-laboratory/by-trx/${trxId}`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async approveRegister(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.PANEL_TRACKING}/approve-register/judgment/${Enviroment.LANGUAGE}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getApproveRegister(pharmacy, page) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/approve-register/judgment/country/${Enviroment.LANGUAGE}/pharmacy/${pharmacy}/page/${page}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async saveStatus(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.PANEL_TRACKING}/save-status/${Enviroment.LANGUAGE}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async resendEmail(trxId) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.SUCCESS_TRANSACTION}/emails/resend`,
			data: { trx_id: trxId },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async deleteProduct(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.PANEL_TRACKING}/cancellation/${Enviroment.LANGUAGE}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async restoreStatus(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.PANEL_TRACKING}/restore-status`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async exportPurchases(token, country, pharmacy, from, to) {
		const params = { country, pharmacy };
		if (from && to) {
			params.from = from;
			params.to = to;
		}

		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/purchases/export`,
			params: params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
